<template>
    <div>
        <div class="container">
            <div class="titleBar">
                <span class="mgl20">{{$t('CreatePage.editUser')}}</span>                        
                <el-button class="rightButton" @click="goBack">{{$t('CreatePage.backButton')}}</el-button>
            </div>           
            <input name="text1" style="position: absolute;left: -10000px;top: -10000px;"/>
            <input type="password" name="password1" style="position: absolute;left: -10000px;top: -10000px;"/>                      
                       
            <el-form class="form-box" :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px">
                <div class="formTitle">
                    <span>{{$t('CreatePage.baseInfo')}}</span>                        
                </div>                     
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.company')" prop="nickname">                           
                            <el-input v-model="ruleForm.nickname" class="formWidth"></el-input>     
                        </el-form-item>                          
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.userName')" prop="account">
                            <el-input v-model="ruleForm.account" class="formWidth" disabled></el-input>                            
                        </el-form-item>  
                    </el-col>    
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.userPass')" prop="userPass">
                            <!-- <el-input v-model="ruleForm.userPass" class="formWidth"></el-input>     -->
                            <el-button type="primary" @click="changePass">{{$t('Button.changePass')}}</el-button>         
                        </el-form-item>  
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.userEmail')" prop="email">
                            <el-input v-model="ruleForm.email" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.contact')" prop="contact">
                            <el-input v-model="ruleForm.contact" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('UserManage.phone')" prop="cellphone">
                            <el-input v-model="ruleForm.cellphone" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>                    
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item :label="$t('UserManage.remark')" prop="remark">
                            <el-input v-model="ruleForm.remark" style="width: 93.5%"></el-input>
                        </el-form-item>
                    </el-col>                 
                </el-row>

                <div class="formTitle">
                    <span>{{$t('CreatePage.permission')}}</span>                        
                </div>  

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.taskManage.all" @change="taskManagePer">{{$t('UserManage.taskPer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.taskManage.add" class="perblock mb10 mt10">{{$t('UserManage.taskPer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.taskManage.edit" class="perblock mb10">{{$t('UserManage.taskPer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.taskManage.delete" class="perblock mb10">{{$t('UserManage.taskPer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.deviceManage.all" @change="deviceManagePer">{{$t('UserManage.devicePer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.deviceManage.import" class="perblock mb10 mt10">{{$t('UserManage.devicePer.import')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.add" class="perblock mb10 mt10">{{$t('UserManage.devicePer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.move" class="perblock mb10 mt10">{{$t('UserManage.devicePer.move')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.edit" class="perblock mb10">{{$t('UserManage.devicePer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.deviceManage.delete" class="perblock mb10">{{$t('UserManage.devicePer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>             

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.groupManage.all" @change="groupManagePer">{{$t('UserManage.groupPer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.groupManage.add" class="perblock mb10 mt10">{{$t('UserManage.groupPer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.groupManage.move" class="perblock mb10 mt10">{{$t('UserManage.groupPer.move')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.groupManage.edit" class="perblock mb10">{{$t('UserManage.groupPer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.groupManage.delete" class="perblock mb10">{{$t('UserManage.groupPer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>     

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.fileMenu.all" @change="fileMenuPer">{{$t('UserManage.filePer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.fileMenu.add" class="perblock mb10 mt10">{{$t('UserManage.filePer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.fileMenu.edit" class="perblock mb10">{{$t('UserManage.filePer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.fileMenu.delete" class="perblock mb10">{{$t('UserManage.filePer.delete')}}</el-checkbox>
                    </el-col>
                </el-row> 

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.userManage.all" @change="userManagePer">{{$t('UserManage.userPer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.userManage.add" class="perblock mb10 mt10">{{$t('UserManage.userPer.create')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.userManage.edit" class="perblock mb10">{{$t('UserManage.userPer.edit')}}</el-checkbox>                     
                        <el-checkbox v-model="permissions.userManage.delete" class="perblock mb10">{{$t('UserManage.userPer.delete')}}</el-checkbox>
                    </el-col>
                </el-row>   

                <el-row :gutter="10" class="perBox perUnderLine">
                    <el-col :span="8">
                        <el-checkbox v-model="permissions.noticeManage.all" @change="noticeManagePer">{{$t('UserManage.noticePer.manage')}}</el-checkbox>   
                    </el-col>
                    <el-col :span="8">
                        <!-- <el-checkbox v-model="permissions.noticeManage.add" class="perblock mb10 mt10">{{$t('UserManage.noticePer.create')}}</el-checkbox>
                        <el-checkbox v-model="permissions.noticeManage.edit" class="perblock mb10">{{$t('UserManage.noticePer.edit')}}</el-checkbox>
                        <el-checkbox v-model="permissions.noticeManage.delete" class="perblock mb10">{{$t('UserManage.noticePer.delete')}}</el-checkbox> -->
                        <el-checkbox v-model="permissions.noticeManage.search" class="perblock mb10 mt10">{{$t('UserManage.noticePer.view')}}</el-checkbox>

                    </el-col>
                </el-row>                 
                <el-form-item class="buttonCenter">
                    <el-button type="primary" @click="onSubmit('ruleForm')">{{$t('Button.submit')}}</el-button>
                    <el-button @click="goBack">{{$t('Button.back')}}</el-button>
                </el-form-item>                   
            </el-form> 
            <el-dialog :title="$t('Home.changePass')" :visible.sync="dialogChangePass" @close="closeDialog('ruleFormPass')" width="35%">
                <div class="font-set">
                    <el-form :model="ruleFormPass" :rules="rulesPass" ref="ruleFormPass" status-icon label-position="left" label-width="150px">
                        <el-form-item :label="$t('Home.oldPass')" prop="oldPassword">
                            <el-input type="password" v-model="ruleFormPass.oldPassword" show-password :placeholder="$t('Home.oldPassInput')"></el-input>
                        </el-form-item>            
                        <el-form-item :label="$t('Home.newPass')" prop="newPassword">
                            <el-input type="password" v-model="ruleFormPass.newPassword" show-password :placeholder="$t('Home.newPassInput')"></el-input>
                        </el-form-item>    
                        <el-form-item :label="$t('Home.confirmPass')" prop="newPasswordAgain">
                            <el-input type="password" v-model="ruleFormPass.newPasswordAgain" show-password :placeholder="$t('Home.confirmPassInput')"></el-input>
                        </el-form-item>                              
                        <el-form-item>
                            <el-button type="primary" @click="onSubmitPass('ruleFormPass')">{{$t('Button.submit')}}</el-button>
                            <el-button @click="closeDialog('ruleFormPass')">{{$t('Button.back')}}</el-button>
                        </el-form-item>
                    </el-form>            
                                        
                </div>            
            </el-dialog>  
        </div>


    </div>
</template>

<script>
import bus from '../../common/bus';
import Tools from '../../common/Tools';
import api from '../../../api/api.js';
import apiAllSystem from '../../../api/apiAllSystem.js';

export default {
    name: 'taskCreate',
    components: { 

    },     
    data() {
        return {
            labelPosition: "top",
            pagesize: 10, //每页显示条数
            curPage: 1,   //当前页数         
            multipleSelection: [],
            ruleForm: {
                nickname: "",
                account: "",
                email: "",
                contact: "",
                cellphone: "",
                remark: "",
                sssid: ""
            },
            companySelect: [],
            tableData: [],
            permissions: {
                taskManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                deviceManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                groupManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                fileMenu: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                userManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                noticeManage: { all: false, add: false, edit: false, delete: false, move: false, export: false, import: false, search: true },
            },
            dialogChangePass: false,
            ruleFormPass: {
                oldPassword: "",
                newPassword: "",
                newPasswordAgain: "",
            }            
        }
    },
    
    computed: {
        rules() {
            return {
                // nickname: [
                //     { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                // ],
                // account: [
                //     { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                // ],
                // email: [
                //     { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                // ],   
                nickname: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: "string", pattern: /^[\u4E00-\u9FA5a-zA-Z0-9]+([_-][\u4E00-\u9FA5a-zA-Z0-9]+)*$/, min: 2, max: 20, message: this.$t('Rules.name'), trigger: 'blur'},
                ],
                account: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},                    
                    { type: "string", pattern: /^[a-zA-Z0-9_-]+$/, min: 3, max: 20, message: this.$t('Rules.userName'), trigger: 'blur'},
                ],
                email: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: 'email', message: this.$t('Rules.userEmail'), trigger: 'blur' }
                ],   
                cellphone: [
                    { type: "string", pattern: /^[+]?[0-9()]+([\s-][0-9()]+)*$/, min: 6, max: 20, message: this.$t('Rules.phone'), trigger: 'blur'},
                ],                                                       
            }
        },

        rulesPass() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback();
                } else {
                    if (this.ruleForm.newPasswordAgain !== '') {
                        this.$refs.ruleFormPass.validateField('newPasswordAgain');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback();
                } else if (value !== this.ruleFormPass.newPassword) {
                    callback(new Error(this.$t('Rules.inconsistent')));
                } else {
                    callback();
                }
            };               
            return {
                oldPassword: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: "string", pattern: /^[a-zA-Z0-9~!@#$%^&*()_+-=]+$/, min: 6, max: 20, message: this.$t('Rules.userPass'), trigger: 'blur'},
                ],
                newPassword: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: "string", pattern: /^[a-zA-Z0-9~!@#$%^&*()_+-=]+$/, min: 6, max: 20, message: this.$t('Rules.userPass'), trigger: 'blur'},
                    { validator: validatePass, trigger: 'blur' }
                ],
                newPasswordAgain: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: "string", pattern: /^[a-zA-Z0-9~!@#$%^&*()_+-=]+$/, min: 6, max: 20, message: this.$t('Rules.userPass'), trigger: 'blur'},
                    { validator: validatePass2, trigger: 'blur' }
                ],
            }
        }        
    },
    created() {
        this.getData();
        // this.getData();
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },      

        getData() {
            let basePer = {
                all: true,
                add: true,
                edit: true,
                delete: true,
                move: true,
                export: true,
                import: false
            }

            this.permissions = {
                taskManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                deviceManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                groupManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                fileMenu: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                userManage: { all: true, add: true, edit: true, delete: true, move: true, export: true, import: false },
                noticeManage: { all: false, add: false, edit: false, delete: false, move: false, export: false, import: false, search: true },
            }

            this.ruleForm = JSON.parse(this.$route.query.row);

            api.getPermission({usersssid: this.ruleForm.sssid})
            .then(res => {
                if(res.state){
                    this.permissions.taskManage = res.value.TaskPermission;
                    this.permissions.deviceManage = res.value.TrackerPermission;
                    this.permissions.groupManage = res.value.TrackerGroupPermission;
                    this.permissions.fileMenu = res.value.FilePermission;
                    this.permissions.userManage = res.value.UserPermission;
                    this.permissions.noticeManage = res.value.MessagePermission;
                } else {
                    this.$message.error(res.value.text);
                }

            })            
        },

        taskManagePer(val){
            if(val == true) { this.permissions.taskManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.taskManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },

        deviceManagePer(val){
            if(val == true) { this.permissions.deviceManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.deviceManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },

        groupManagePer(val){
            if(val == true) { this.permissions.groupManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.groupManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },

        fileMenuPer(val){
            if(val == true) { this.permissions.fileMenu = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.fileMenu = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },
        
        userManagePer(val){
            if(val == true) { this.permissions.userManage = {add: true, edit: true, delete: true, move: true, export: true, import: true}; } 
            else { this.permissions.userManage = {add: false, edit: false, delete: false, move: false, export: false, import: false}; }
        },
        
        noticeManagePer(val){
            if(val == true) { this.permissions.noticeManage = {add: true, edit: true, delete: true, move: true, export: true, import: true, search: true}; } 
            else { this.permissions.noticeManage = {add: false, edit: false, delete: false, move: false, export: false, import: false, search: false}; }
        },       

        onSubmit(formName) {     
            this.$refs[formName].validate((valid) => {
                if (valid) {     
                    let params = {
                        fathersssid: localStorage.getItem('sssid'),
                    };                    
                    let bodyParams = {
                        user: this.ruleForm,
                        fotapermission: {
                            TaskPermission: this.permissions.taskManage,
                            TrackerPermission: this.permissions.deviceManage,
                            TrackerGroupPermission: this.permissions.groupManage,
                            FilePermission: this.permissions.fileMenu,
                            UserPermission: this.permissions.userManage,
                            MessagePermission: this.permissions.noticeManage,
                        }

                    };  
                
                    api.editUserWithPer(params, bodyParams)
                    .then(res => {
                        if(res.state){
                            this.$message.success(this.$t('Message.success'));
                            this.$router.push({path:'/userManage'});
                        } else {
                            this.$message.error(res.value.text);
                        }
                        
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('Message.reqError'));
                    });  
                }
            })                                                  
 
        },

        changePass() {
            this.dialogChangePass = true;
        },

        closeDialog(formName) {
            this.$refs[formName].resetFields();
            this.dialogChangePass = false;
        },

        onSubmitPass(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        usersssid: this.ruleForm.sssid,
                        oldpassword: this.ruleFormPass.oldPassword,
                        newpassword: this.ruleFormPass.newPassword
                    }
                    api.changePassword(params)
                    .then(res => {
                        if(res.state){
                            this.$message.success(this.$t('Message.success'));
                            this.dialogChangePass = false;
                        } else {
                            if(res.value.code == -1){
                                this.$message.error(this.$t('Message.passwordMess'));
                            } else if(res.value.code == -2){
                                this.$message.error(this.$t('Message.passwordMess'));
                            }
                        } 
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('Message.reqError'));
                    });  
                } else {
                    return false;
                }
            });            
        }        
    }
};
</script>

<style scoped>
.perBox {
    display: flex;
    align-items: center
}
.perUnderLine {
    border-bottom: 1px solid #E9E9E9;
}
.perblock {
    display:block
}
</style>